module.exports = __webpack_public_path__ + "static/media/funds.64b38974.svg";